module.exports = __webpack_public_path__ + "img/box01_01.e716aa13.jpg";